// extracted by mini-css-extract-plugin
export default {"readerContainer":"Modal_2_1_readerContainer__S97Wr","reader":"Modal_2_1_reader__mzaKf","readerBg":"Modal_2_1_readerBg__r2k+Z","readerBgText":"Modal_2_1_readerBgText__enc8Y"};